<template>
    <div class="settings">
        <v-container>
            <div class="card-curvey">
                <h2 class="mb-3">Channel Configuration</h2>
                <v-layout row wrap>
                    <v-flex xs6>
                        <label>Facebook Iframe</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="settings.iframe_link"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>Direct Line</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="settings.direct_line"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>Facebook Page Access Token</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="settings.facebook_access_token"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>External Analytics API URL</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="settings.external_analytics"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>Secondary External Analytics API URL</label>
                        <v-text-field
                          class="mt-2"
                          outline
                          v-model="settings.external_analytics_second"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>
            <hr>
            <div class="text-sm-right mt-5">
                <v-btn color="primary" @click="dialog = true" large round>ADD LANGUAGE</v-btn>
                <v-dialog
                        v-model="dialog"
                        width="500"
                >
                    <v-card >
                        <v-card-title
                                class="v-card__title--primary primary white--text"

                        >
                            <h3>Add New Language</h3>
                        </v-card-title>
                        <div class="pa-4">
                            <v-autocomplete
                                    v-model="selectedLang"
                                    :items="langIso"
                                    item-text="name"
                                    item-value="code"
                                    class="mt-1 right-radius"
                                    solo
                                    label="Search Languages"
                            >
                            </v-autocomplete>
                            <v-select
                                    class="mt-2"
                                    outline
                                    v-model="selectedEngine"
                                    placeholder="Select Engine"
                                    :items="['luis','wit']"
                            >
                            </v-select>
                            <v-btn
                                    round
                                    class="btn-input"
                                    color="primary"
                                    @click="pushLang()"
                                    :disabled="!selectedEngine || !selectedLang"
                            >
                                Add Language
                            </v-btn>
                        </div>

                    </v-card>
                </v-dialog>
            </div>
            <div class="card-curvey" v-for="(langObj, lang) in settings.nlp">
                <v-layout row class="align-center mb-3">
                    <v-flex sm6><h2 class="capitalize">{{getLang(lang)}} / {{langObj.engine}}</h2></v-flex>
                    <v-flex sm6 class="text-sm-right">
                        <v-btn fab dark small
                               color="error"
                               @click="deleteLang(lang)"
                        >
                            <v-icon dark>delete_outline</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs6>
                        <label>Minimum Score</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="langObj.min_score"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>App ID</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="langObj.app_id"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>API KEY</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="langObj.api_key"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <label>Hostname</label>
                        <v-text-field
                                class="mt-2"
                                outline
                                v-model="langObj.hostname"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>

            <v-flex xs12 >
                <v-btn  large round color="primary" @click="updateSettings">
                    Save
                </v-btn>
            </v-flex>
        </v-container>
    </div>
</template>

<script>
    import common from "../utils/common";
    import langIso from "../utils/lang-iso"
    export default {
        name: "settings",
        data () {
            return {
                settings:{
                    iframe_link:'',
                    direct_line:'',
                    facebook_access_token:'',
                    external_analytics: '',
                    external_analytics_second: '',
                    nlp: {

                    }
                },
                selectedLang: '',
                selectedEngine: '',
                langIso,
                dialog: false
            }
        },
        mounted() {
          this.getSettings()
        },
        methods: {
            getSettings() {
                this.$http_bot.get('/settings/')
                    .then(response=>{
                        this.settings = response.data
                        if (!this.settings.nlp) {
                            this.settings.nlp = {}
                        }
                    })
                    .catch(error=>{
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    })
            },
            updateSettings() {
                this.$http.put('/settings/', {
                    bot_id: this.botId,
                    settings: this.settings
                })
            },
            pushLang () {
                if (!this.settings.nlp[this.selectedLang]) {
                    this.settings.nlp[this.selectedLang] = {
                        engine: this.selectedEngine,
                        min_score: '',
                        app_id: '',
                        api_key: '',
                        hostname: '',
                    }
                    this.selectedLang = ''
                    this.selectedEngine = ''
                    this.dialog = false
                }
            },
            deleteLang (lang) {
                delete this.settings.nlp[lang]
                this.selectedLang = ''
                this.$forceUpdate();
            },
            getLang(code) {
                let index = this.langIso.findIndex( item=> {
                    return item.code === code
                })
                return this.langIso[index].name
            }
        },
        computed: {
            botId() {
                return this.$store.state.bot.botId
            }
        }
    }
</script>

<style scoped>
    .btn-input {
        height: 45px;
    }
    .add-lang {
        max-width: 500px;
        margin: auto;
    }
</style>
